export default __webpack_public_path__ + "static/media/participant-card.6e32ea77.svg";